import {
  EXCEEDS_EDM_NUMBER_SIZE,
  VALUE_MUST_BE_VALID_EDMS_NUMBER,
} from '@src/formSchemas/formSchemaUtils';
import { RegisterOptions } from 'react-hook-form';

export const edmsReferenceValidation = (t: (str: string) => string): RegisterOptions => {
  return {
    maxLength: {
      value: 18,
      message: t(EXCEEDS_EDM_NUMBER_SIZE),
    },
    pattern: {
      value: /^(\s*|\d+)$/,
      message: t(VALUE_MUST_BE_VALID_EDMS_NUMBER),
    },
  };
};
